/**
 * Gets keyboard-focusable elements within a specified element
 * @returns {Array}
 */
export const getKeyboardFocusableElements = (element?: any) => {
  const target = element || document;
  return [...target.querySelectorAll('a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')].filter(
    (el: any) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
  );
};
